import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject, isDevMode } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { ConnectivityService } from '@app/core/services/connectivity.service';

export const connectivityInterceptor: HttpInterceptorFn = (request, next) => {
  const connectivity = inject(ConnectivityService);

  return next(request).pipe(
    catchError((error: HttpErrorResponse) => {
      // 5xx, 0 (network), timeout. Skip 4xx (client errors, app handles them).
      if (error.status >= 500 || error.status === 0) {
        connectivity.recordError(request.url, error.status);
        if (isDevMode()) console.warn(`[Connectivity] ${error.status} on ${request.url}`);
      }
      return throwError(() => error);
    }),
  );
};
